import styled from "styled-components";
import H1 from "./H1";

const H5 = styled(H1).attrs({
  as: "h5",
})`
  font-size: ${({ size, theme }) => size || theme.fontSizes.h5};
  font-weight: ${({ weight, theme }) => weight || theme.fontWeights.bold};
`;

export default H5;
